import React from 'react';
import { Heart, Sprout, BookOpen } from 'lucide-react';
import '../../styles/AboutSection.css';

const AboutSection = ({ data }) => {
  return (
    <section className="about-section section-animate">
      <div className="container">
        <h2 className="section-title">À Propos</h2>
        
        <div className="about-grid">
          <div className="about-bio">
            <h3>Mon Parcours</h3>
            <p>{data.bio}</p>
          </div>
          
          <div className="about-cards">
            <div className="about-card">
              <BookOpen className="card-icon" />
              <h4>Formation</h4>
              <p>{data.formation}</p>
            </div>
            
            <div className="about-card">
              <Heart className="card-icon" />
              <h4>Inspirations</h4>
              <p>{data.inspirations}</p>
            </div>
            
            <div className="about-card">
              <Sprout className="card-icon" />
              <h4>Philosophie</h4>
              <p>Une cuisine qui nourrit le corps et respecte la terre, où chaque plat raconte une histoire de tradition et d'innovation.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;